{
  "title": "What to Do When Your Eligibility Proof Is Rejected",
  "description": "How to diagnose and fix a \"Rejected\" status on the \"Student Eligibility Verification\" page.",
  "headings": ["Symptom", "Common Causes", "How to Diagnose", "Expected Result", "Still Stuck?"],
  "symptom": "On the \"Student Eligibility Verification\" page, \"My eligibility status\" shows \"Rejected\" along with a reason.",
  "causes": [
    "The uploaded document type isn't one this competition accepts",
    "The scan or photo is blurry or incomplete, so the organizer couldn't read it",
    "The name, school, or department on the document doesn't match your registration details",
    "The document has expired or isn't from the current term"
  ],
  "diagnosis": [
    {
      "title": "Step 1",
      "description": "Read the \"Rejection reason\" field on the \"My eligibility status\" card — it's the specific note the competition's organizer entered during manual review."
    },
    {
      "title": "Step 2",
      "description": "Compare it against the reason shown to figure out whether you need to fix the document itself (rescan it, use a different document) or the details you entered (school, department, student number)."
    },
    {
      "title": "Step 3",
      "description": "Confirm the file you're about to re-upload is PDF, PNG, JPG, or JPEG, and no larger than 10 MB."
    }
  ],
  "resolution": "Click \"Replace file\" to expand the form — it's prefilled with the proof type, school, department, and student number you entered before, so you only need to change whatever the rejection reason points to, or swap the file. After you submit, the status returns to \"Under review\" while the organizer reviews it again. See \"How to Upload Your Eligibility Enrollment Proof\" for the full steps.",
  "stillStuck": [
    "The competition name",
    "The full text of the rejection reason",
    "How many times you've re-uploaded",
    "A screenshot"
  ],
  "doNotProvide": [
    "Your password",
    "A verification code",
    "A token",
    "The enrollment proof file itself"
  ],
  "nextSteps": "Eligibility is reviewed manually by that competition's organizer (its competition admin), not decided automatically by the platform. If you have questions about the rejection reason or think it's a mistake, contact that competition's organizer directly rather than platform support — this status doesn't affect your already-completed registration, so you can keep working on registration and submission steps while you wait."
}
